/**
 * ModuleRoute — guards a route by a feature module. If the tenant has the module
 * off (or the user lacks access), bounce to the dashboard (the nav already hides it;
 * this stops direct-URL access). Only redirects once the tenant is known, to avoid
 * a flash-redirect during initial auth bootstrap.
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFeature } from "@/hooks/useFeature";
import { useAuthStore, type ModuleFeatures } from "@/store/authStore";

export default function ModuleRoute({
  feature,
  children,
}: {
  feature: keyof ModuleFeatures;
  children: ReactNode;
}) {
  const tenant = useAuthStore((s) => s.tenant);
  const enabled = useFeature(feature);
  if (tenant && !enabled) return <Navigate to="/" replace />;
  return <>{children}</>;
}
